// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3yxul","icons":"_1OXKD","icon":"_3D_xa","display":"ttEpN","name":"_1g36_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/style.css
// module id = 544
// module chunks = 0